// extracted by mini-css-extract-plugin
export var bodySections = "_bu-8";
export var gray = "_bu-7";
export var green = "_bu-4";
export var iconContainer = "_bu-9";
export var iconWidgetContainer = "_bu-1";
export var phoneIcon = "_bu-2";
export var red = "_bu-5";
export var statusDot = "_bu-3";
export var widgetContainer = "_bu-0";
export var yellow = "_bu-6";